import { render } from "./payment-login-check.vue?vue&type=template&id=12e0095d&ts=true"
import script from "./payment-login-check.vue?vue&type=script&lang=ts"
export * from "./payment-login-check.vue?vue&type=script&lang=ts"

import "./payment-login-check.vue?vue&type=style&index=0&id=12e0095d&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__